export interface PointStyleRule {
    quantityFrom: number | null;
    quantityTo: number | null;
    color: PointStyleRuleColor;

    // this is set here in UI:
    newGeneration: boolean;
}

export enum PointStyleRuleColor {
    Green = 'Green',
    Yellow = 'Yellow',
    Red = 'Red'
}

class PointStyleRuleHelperDefinition {
    clone(rule: PointStyleRule, newGeneration: boolean): PointStyleRule {
        return {
            quantityFrom: rule.quantityFrom,
            quantityTo: rule.quantityTo,
            color: rule.color,
            newGeneration
        };
    }
}

export const PointStyleRuleHelper = new PointStyleRuleHelperDefinition();